export interface WithDrivers {
  /**
   * imposta i driver collegati alla configurazione
   */
  setDrivers(): void;
}
